import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17l9 5l9 -5v-3l-9 5l-9 -5v-3l9 5l9 -5v-3l-9 5l-9 -5l9 -5l5.418 3.01","key":"svg-0"}]]

const IconBrandDatabricks = createReactComponent('outline', 'brand-databricks', 'BrandDatabricks', __iconNode);

export default IconBrandDatabricks;